var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9075 17.8499H10.661C6.9079 17.8499 3.92468 14.8667 3.92468 11.1136C3.92468 7.36052 6.9079 4.3773 10.661 4.3773H29.9075C33.6606 4.3773 36.6438 7.36052 36.6438 11.1136C36.6438 14.8667 33.6606 17.8499 29.9075 17.8499Z",
    fill: "#3C3C43",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_121_4400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6233 20.7369C16.9381 20.7369 21.2466 16.4284 21.2466 11.1136C21.2466 5.79881 16.9381 1.49033 11.6233 1.49033C6.30849 1.49033 2 5.79881 2 11.1136C2 16.4284 6.30849 20.7369 11.6233 20.7369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.006 11.1136C21.006 16.2955 16.8052 20.4963 11.6233 20.4963C6.44136 20.4963 2.24058 16.2955 2.24058 11.1136C2.24058 5.93168 6.44136 1.73091 11.6233 1.73091C16.8052 1.73091 21.006 5.93168 21.006 11.1136Z",
    stroke: "url(#paint0_linear_121_4400)",
    strokeWidth: 0.481164
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.006 11.1136C21.006 16.2955 16.8052 20.4963 11.6233 20.4963C6.44136 20.4963 2.24058 16.2955 2.24058 11.1136C2.24058 5.93168 6.44136 1.73091 11.6233 1.73091C16.8052 1.73091 21.006 5.93168 21.006 11.1136Z",
    stroke: "url(#paint1_linear_121_4400)",
    strokeWidth: 0.481164
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_121_4400",
    x: 0.0753443,
    y: 0.527998,
    width: 23.0959,
    height: 23.0959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.962328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.962328
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_4400"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0962328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.144349
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_121_4400",
    result: "effect2_dropShadow_121_4400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_121_4400",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_4400",
    x1: 2.09417,
    y1: 1.49033,
    x2: 2.09417,
    y2: 20.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_4400",
    x1: 2,
    y1: 1.49033,
    x2: 2,
    y2: 20.7369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOff);
export default __webpack_public_path__ + "static/media/toggle-off.e2ebe6e5.svg";
export { ForwardRef as ReactComponent };